import { mapLegalEntityObject } from "./legal-entity";
import { mapClientPreviewObjectToClient } from "./client";
export var mapUserObjectToUser = function (_a) {
    var id = _a.id, email = _a.email, lang = _a.lang, name = _a.name, role = _a.role, client_id = _a.client_id, client = _a.client, email_verified_at = _a.email_verified_at, legal_entity = _a.legal_entity, created_at = _a.created_at;
    return ({
        id: id,
        email: email,
        lang: lang,
        name: name,
        role: role,
        clientId: client_id,
        client: client ? mapClientPreviewObjectToClient(client) : void 0,
        emailVerifiedAt: email_verified_at,
        legalEntity: legal_entity ? mapLegalEntityObject(legal_entity) : null,
        createdAt: created_at,
    });
};
